import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><div parentName="p" {...{
        "className": "mermaid"
      }}><svg parentName="div" {...{
          "aria-role-description": ["flowchart-v2"],
          "role": "graphics-document document",
          "viewBox": "-8 -8 584.03125 176",
          "style": {
            "maxWidth": "584.03125px"
          },
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "100%",
          "id": "mermaid-0"
        }}><style parentName="svg">{`#mermaid-0{font-family:arial,sans-serif;font-size:16px;fill:#333;}#mermaid-0 .error-icon{fill:#552222;}#mermaid-0 .error-text{fill:#552222;stroke:#552222;}#mermaid-0 .edge-thickness-normal{stroke-width:2px;}#mermaid-0 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-0 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-0 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-0 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-0 .marker{fill:#333333;stroke:#333333;}#mermaid-0 .marker.cross{stroke:#333333;}#mermaid-0 svg{font-family:arial,sans-serif;font-size:16px;}#mermaid-0 .label{font-family:arial,sans-serif;color:#333;}#mermaid-0 .cluster-label text{fill:#333;}#mermaid-0 .cluster-label span,#mermaid-0 p{color:#333;}#mermaid-0 .label text,#mermaid-0 span,#mermaid-0 p{fill:#333;color:#333;}#mermaid-0 .node rect,#mermaid-0 .node circle,#mermaid-0 .node ellipse,#mermaid-0 .node polygon,#mermaid-0 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-0 .flowchart-label text{text-anchor:middle;}#mermaid-0 .node .label{text-align:center;}#mermaid-0 .node.clickable{cursor:pointer;}#mermaid-0 .arrowheadPath{fill:#333333;}#mermaid-0 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-0 .flowchart-link{stroke:#333333;fill:none;}#mermaid-0 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-0 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-0 .labelBkg{background-color:rgba(232, 232, 232, 0.5);}#mermaid-0 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-0 .cluster text{fill:#333;}#mermaid-0 .cluster span,#mermaid-0 p{color:#333;}#mermaid-0 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-0 .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#333;}#mermaid-0 :root{--mermaid-font-family:arial,sans-serif;}`}</style><g parentName="svg"><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "6",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 0 L 10 5 L 0 10 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "4.5",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 5 L 10 10 L 10 0 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "11",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleEnd"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "-1",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleStart"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "12",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "-1",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><g parentName="g" {...{
              "className": "root"
            }}><g parentName="g" {...{
                "className": "clusters"
              }}></g><g parentName="g" {...{
                "className": "edgePaths"
              }}><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-router LE-subgraphA",
                  "id": "L-router-subgraphA-0",
                  "d": "M298.359,61.545L313.293,56.038C328.227,50.53,358.094,39.515,387.078,34.008C416.061,28.5,444.162,28.5,458.212,28.5L472.263,28.5"
                }}></path><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                  "style": {
                    "fill": "none",
                    "strokeWidth": "2px",
                    "strokeDasharray": "3"
                  },
                  "className": "edge-thickness-normal edge-pattern-dotted flowchart-link LS-router LE-subgraphB",
                  "id": "L-router-subgraphB-0",
                  "d": "M298.359,98.455L313.293,103.962C328.227,109.47,358.094,120.485,387.078,125.992C416.061,131.5,444.162,131.5,458.212,131.5L472.263,131.5"
                }}></path><path parentName="g" {...{
                  "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                  "style": {
                    "fill": "none"
                  },
                  "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-client LE-router",
                  "id": "L-client-router-0",
                  "d": "M61.328,80L72.741,80C84.154,80,106.979,80,128.921,80C150.864,80,171.922,80,182.452,80L192.981,80"
                }}></path></g><g parentName="g" {...{
                "className": "edgeLabels"
              }}><g parentName="g" {...{
                  "transform": "translate(387.9609375, 28.5)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-64.6015625, -28.5)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "57",
                      "width": "129.203125"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`Subscribes`}<br parentName="span"></br>{`over WebSocket`}<br parentName="span"></br>{`(or via callback)`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(387.9609375, 131.5)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-54.7421875, -28.5)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "57",
                      "width": "109.484375"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`Can query for`}<br parentName="span"></br>{`entity fields`}<br parentName="span"></br>{`as needed`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(129.8046875, 80)",
                  "className": "edgeLabel"
                }}><g parentName="g" {...{
                    "transform": "translate(-43.4765625, -19)",
                    "className": "label"
                  }}><foreignObject parentName="g" {...{
                      "height": "38",
                      "width": "86.953125"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "edgeLabel"
                        }}>{`Subscribes`}<br parentName="span"></br>{`over HTTP`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "nodes"
              }}><g parentName="g" {...{
                  "transform": "translate(30.6640625, 80)",
                  "id": "flowchart-client-0",
                  "className": "node default secondary flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "34",
                    "width": "61.328125",
                    "y": "-17",
                    "x": "-30.6640625",
                    "ry": "5",
                    "rx": "5",
                    "style": {},
                    "className": "basic label-container"
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-23.1640625, -9.5)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "19",
                      "width": "46.328125"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Client`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(248.3203125, 80)",
                  "id": "flowchart-router-1",
                  "className": "node default default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "53",
                    "width": "100.078125",
                    "y": "-26.5",
                    "x": "-50.0390625",
                    "ry": "26.5",
                    "rx": "26.5",
                    "style": {}
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-35.9140625, -19)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "38",
                      "width": "71.828125"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`GraphOS`}<br parentName="span"></br>{`Router`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(522.796875, 28.5)",
                  "id": "flowchart-subgraphA-2",
                  "className": "node default default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "53",
                    "width": "90.46875",
                    "y": "-26.5",
                    "x": "-45.234375",
                    "ry": "0",
                    "rx": "0",
                    "style": {},
                    "className": "basic label-container"
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-37.734375, -19)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "38",
                      "width": "75.46875"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Stocks`}<br parentName="span"></br>{`subgraph`}</span></div></foreignObject></g></g><g parentName="g" {...{
                  "transform": "translate(522.796875, 131.5)",
                  "id": "flowchart-subgraphB-3",
                  "className": "node default default flowchart-label"
                }}><rect parentName="g" {...{
                    "height": "53",
                    "width": "90.46875",
                    "y": "-26.5",
                    "x": "-45.234375",
                    "ry": "0",
                    "rx": "0",
                    "style": {},
                    "className": "basic label-container"
                  }}></rect><g parentName="g" {...{
                    "transform": "translate(-37.734375, -19)",
                    "style": {},
                    "className": "label"
                  }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                      "height": "38",
                      "width": "75.46875"
                    }}><div parentName="foreignObject" {...{
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        },
                        "xmlns": "http://www.w3.org/1999/xhtml"
                      }}><span parentName="div" {...{
                          "className": "nodeLabel"
                        }}>{`Portfolios`}<br parentName="span"></br>{`subgraph`}</span></div></foreignObject></g></g></g></g></g></svg></div></p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`A client executes a GraphQL subscription operation against your router over HTTP:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-graphql",
            "metastring": "title=\"Example subscription\"",
            "title": "\"Example",
            "subscription\"": true
          }}>{`subscription OnStockPricesChanged {
  stockPricesChanged {
    symbol
    price
  }
}
`}</code></pre>
        <ul parentName="li">
          <li parentName="ul">{`The client doesn't use a WebSocket protocol. Instead, it receives updates via `}<a parentName="li" {...{
              "href": "https://www.apollographql.com/docs/router/executing-operations/subscription-multipart-protocol/"
            }}>{`multipart HTTP responses`}</a>{`.`}</li>
          <li parentName="ul">{`By using HTTP for subscriptions, clients can execute all GraphQL operation types over HTTP instead of using two different protocols.`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.apollographql.com/docs/react/data/subscriptions#http"
            }}>{`Apollo Client`}</a>{`, `}<a parentName="li" {...{
              "href": "https://www.apollographql.com/docs/kotlin/essentials/subscriptions#configuring-http-subscriptions"
            }}>{`Apollo Kotlin`}</a>{`, and `}<a parentName="li" {...{
              "href": "https://www.apollographql.com/docs/ios/fetching/subscriptions#http"
            }}>{`Apollo iOS`}</a>{` all support GraphQL subscriptions over HTTP with minimal configuration. See each library's documentation for details. Apollo Client also provides network adapters for the `}<a parentName="li" {...{
              "href": "https://www.apollographql.com/docs/react/data/subscriptions#relay"
            }}>{`Relay`}</a>{` and `}<a parentName="li" {...{
              "href": "https://www.apollographql.com/docs/react/data/subscriptions#urql"
            }}>{`urql`}</a>{` libraries.`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`When your router receives a subscription, it executes that same subscription against whichever subgraph defines the requested field—`}<inlineCode parentName="p">{`stockPricesChanged`}</inlineCode>{` in the code snippet above.`}</p>
        <ul parentName="li">
          <li parentName="ul">{`This communication usually does use a WebSocket subprotocol, for compatibility with most subgraph libraries.`}</li>
          <li parentName="ul">{`With a self-hosted router, you can also configure an `}<a parentName="li" {...{
              "href": "https://www.apollographql.com/docs/router/executing-operations/subscription-support/#http-callback-setup"
            }}>{`HTTP-callback-based protocol`}</a>{`.`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The subgraph periodically sends new data to your router. Whenever it does, the router returns that data to the client in an additional HTTP response part.`}</p>
        <ul parentName="li">
          <li parentName="ul">{`A subscription can include federated entity fields that are defined in other subgraphs. If it does, the router first fetches those fields by querying the corresponding subgraphs, such as the `}<strong parentName="li">{`Portfolios subgraph`}</strong>{` in the diagram above. These queries use HTTP as usual.`}</li>
        </ul>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      